import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'
import DatePicker from '../../../../helpers/ui/DatePicker'

class IndexView extends Component {

    createBloc = new CreateBloc();
    indexBloc = new IndexBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            diklatBknOption: [],
        }
    }


    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`/master/scheduler.html`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Tambah Scheduler</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="job_name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama Scheduler <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="job_name"
                                                    placeholder="Nama Scheduler..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Scheduler"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="job_name"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="job_schedule"
                                                className="col-md-3 col-form-label"
                                            >
                                                Waktu <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="job_schedule"
                                                    placeholder="Waktu..."
                                                    type="text"
                                                    errorMessage="Masukkan Waktu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="job_schedule"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="job_query"
                                                className="col-md-3 col-form-label"
                                            >
                                                Query <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="job_query"
                                                    placeholder="Query..."
                                                    type="text"
                                                    errorMessage="Masukkan Query"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="job_query"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="job_schedule"
                                                className="col-md-3 col-form-label"
                                            >
                                                Next Run <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <div className="customDatePickerWidth">
                                                    <DatePicker
                                                        name="job_nextrun"
                                                        placeholder="Next run"
                                                        errorMessage="Masukkan Next run"
                                                        isWeekday={false}
                                                        dateFormat="dd/MM/yyyy"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="job_id"
                                                className="col-md-3 col-form-label"
                                            >
                                                Status <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <Select
                                                    name="job_status"
                                                    placeholder="Pilih Status..."
                                                    errorMessage="Pilih Status"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    options={[
                                                        {label:"Aktif", value:1},
                                                        {label:"Nonaktif", value:0},
                                                    ]}
                                                />
                                            </Col>
                                        </Row> */}

                                       <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/scheduler.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView